export default "__VITE_ASSET__TAEWxJbW__"